import React from 'react';
import classnames from 'classnames';

import Button from '../button';

import { BaseWidgetProps, FetchProps } from '../../utils/type';

export interface ButtonGroupProps extends BaseWidgetProps {
  widget?: 'button' | 'submit' | 'reset';
  hidden?: boolean;
  theme?: 'default' | 'primary' | 'danger';
  block?: boolean;
  size?: 'md' | 'lg' | 'sm' | 'xs';
  fetch?: FetchProps;
  shape?: 'rect' | 'radius' | 'round' | 'circle';
  ghost?: boolean;
  disabled?: boolean;
  className?: string;
  style?: any;
  cascade?: any;
  preValidate?: any;
  type?: string;
  action?: any[];
  options?: any[];
  align?: 'left' | 'center' | 'right';
  isFixedBottom?: boolean,
  onSubmit?: (props: any, value?: any) => void;
}

function ButtonGroup(props: ButtonGroupProps) {
  const {
    block,
    style,
    type,
    hidden,
    prefixCls = 'crm-button-group',
    options,
    className,
    align,
    isFixedBottom = false,
    ...otherProps
  } = props;

  const cls = classnames(prefixCls, className, {
    [`${prefixCls}-${align}`]: !!align,
    [`${prefixCls}-fixed`]: !!isFixedBottom,
  });

  return (
    <div
      className={cls}
      style={style}
    >
      {
        Array.isArray(options) && options.map((item, index) => {
          const childBtnProps = {
            ...item,
            ...otherProps,
          };
          return <Button key={index} {...childBtnProps} />;
        })
      }
    </div>
  );
}

export default ButtonGroup;
